export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'RUBBY',
    url: 'https://rubby.co.uk',
    logo: 'https://rubby.co.uk/logo.png',
    description: "AI-powered platform that turns children's drawings and photos into custom 3D-printed toys, personalised storybooks, and animated short films.",
    sameAs: [],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@rubby.co.uk',
      areaServed: 'GB',
    },
  };
}

export function getProductSchema(toyName?: string, price?: number) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: toyName || 'Custom 3D-Printed Toy',
    description: "A unique toy created from your child's drawing using AI and 3D printing technology.",
    brand: {
      '@type': 'Brand',
      name: 'RUBBY',
    },
    offers: {
      '@type': 'Offer',
      priceCurrency: 'GBP',
      price: price ? (price / 100).toFixed(2) : '79.00',
      availability: 'https://schema.org/InStock',
      deliveryLeadTime: {
        '@type': 'QuantitativeValue',
        minValue: 10,
        maxValue: 14,
        unitCode: 'DAY',
      },
    },
  };
}

export function getWebPageSchema(name: string, description: string, url: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: 'RUBBY',
      url: 'https://rubby.co.uk',
    },
  };
}
